import React, { FC } from 'react'

import { AdaptedVariant, CreditItem, getInstalmentPayPrice, ShopSelector } from '@/entities/Payments'

import { BASE_URL } from '@/shared/lib/const/env'
import { Margin } from '@/shared/ui/margin'

import { InstallmentCreditItem } from './installment-credit-item'

import cls from './installment-list-presentation.module.scss'

interface InstallmentListPresentationProps {
	installmentData: AdaptedVariant[]
	price: number
	activeBank: string
	onBankChange: (bankId: string) => void
	onSpecialConditionModalOpen: (condition: any) => void
	onApplyInstallment: (installmentCode: string, serviceId?: number) => void
	productId: number
}

export const InstallmentListPresentation: FC<InstallmentListPresentationProps> = ({
	installmentData,
	price,
	activeBank,
	onBankChange,
	onSpecialConditionModalOpen,
	onApplyInstallment,
	productId
}) => {
	const bankData = installmentData.find(({ id }) => id === activeBank)

	return (
		<div className={cls.content}>
			<p className={cls.title}>Рассрочка</p>
			<Margin mb="4x">
				<ShopSelector items={installmentData} onChange={onBankChange} value={activeBank} baseUrl={BASE_URL} />
			</Margin>
			<div className={cls.inner}>
				{/* Standard installments */}
				{bankData?.allowedInstallments?.map(months => (
					<CreditItem
						key={months}
						period={`${months} мес.`}
						payCount={getInstalmentPayPrice(price, months)}
						firstPay={0}
						onApply={() => onApplyInstallment(`0-0-${months}`)}
						withSeparate
						isVsegdada
					/>
				))}

				{/* Special conditions */}
				{bankData?.specialConditions?.map((condition, index) => (
					<InstallmentCreditItem
						key={condition.installmentCode}
						condition={condition}
						isLastCondition={!(bankData.specialConditions.length - 1 - index)}
						onModalOpen={onSpecialConditionModalOpen}
						toOrder={onApplyInstallment}
						relatedPrice={price}
						relatedId={productId}
					/>
				))}
			</div>
		</div>
	)
}
